export default __webpack_public_path__ + "static/media/watch_movie.c1b2efe3.svg";